const initialState = {
  mnpData: {
    portingType: 'CONTRACT_END',
    terms: false,
    msisdn: null,
    provider: {
      providerKey: null,
      networkKey: null
    },
    network: null,
    active: false
  }
}

const OrderMnpModule = {
  namespaced: true,
  state: initialState,
  mutations: {
    storeMnpData (state, mnpData) {
      state.mnpData = mnpData
    }
  },
  getters: {
    mnpData (state) {
      return state.mnpData
    },
    mnpCore (state, getters) {
      if (!state.mnpData.active || !state.mnpData.terms) {
        return null
      }
      return {
        portingMsisdn: state.mnpData.msisdn,
        networkKey: state.mnpData.provider.networkKey,
        providerKey: state.mnpData.provider.providerKey,
        portingDateType: state.mnpData.portingType
      }
    }
  }
}

export default OrderMnpModule
